


































































































































































import router from "@/router/router";
import { CameraImage } from "@/store/modules/CameraImage/interface";
import { store } from "@/store/store";
import Utils from "@/utils/utils";
import Vue from "vue";
import { mapState } from "vuex";
import DeviceCardBoxLapi from "./DeviceCardBoxLapi.vue";
import DeviceCardBoxPycam from "./DeviceCardBoxPycam.vue";

interface DeviceCardBox {
  last_image: CameraImage | null;
  placeholder_name: string;
  image_url: string;
  mounted: boolean;
  number_of_images: number;
  card_class: string;
  button_class: string;
  text_class: string;
}

interface CssStyle {
  color?: string;
  backgroundColor?: string;
}

export default Vue.extend({
  name: "DeviceCardBox",
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  components: {
    DeviceCardBoxLapi,
    DeviceCardBoxPycam
  },
  async created() {
    this.get_last_image()
      .then((camera_image: CameraImage | null) => {
        this.last_image = camera_image;
        this.mounted = true;
      })
      .catch((error) => {
        this.last_image = null;
        this.mounted = true;
      });
  },
  data(): DeviceCardBox {
    return {
      last_image: null,
      placeholder_name: "/no-image.png",
      number_of_images: 0,
      image_url: "",
      mounted: false,
      card_class: "mx-auto my-12 card-style standart-card-height",
      button_class: "mr-9 download_button_style",
      text_class: "subtitle-style text-subtitle-1 col-style"
    };
  },
  methods: {
    get_last_image(): Promise<CameraImage | null> {
      return new Promise((resolve, reject) => {
        const images = store.getters.CAMERA_IMAGE_ALL_ID;
        const actual_date = Date.now();
        const images_by_id = images
          .filter(
            (image_id) =>
              store.getters.CAMERA_IMAGE_BY_ID[image_id].material === this.device._id &&
              Utils.getDifferenceBetweenDate(
                new Date(store.getters.CAMERA_IMAGE_BY_ID[image_id].date).getTime(),
                actual_date
              ) <= 1
          )
          .sort((a, b) => {
            return (
              new Date(store.getters.CAMERA_IMAGE_BY_ID[a].date).getTime() -
              new Date(store.getters.CAMERA_IMAGE_BY_ID[b].date).getTime()
            );
          });
        if (images_by_id.length > 0)
          return resolve(store.getters.CAMERA_IMAGE_BY_ID[images_by_id[images_by_id.length - 1]]);
        else return reject(null);
      });
    },
    redirectToDevicePage(): void {
      router.push({ path: `/device?deviceId=${this.device._id}` });
    },
    findImageNumber(): void {
      this.number_of_images = store.getters.CAMERA_IMAGE_ALL_ID.filter(
        (image_id) => store.getters.CAMERA_IMAGE_BY_ID[image_id].material === this.device._id
      ).length;
    },
    downloadCurrentImage(): void {
      Utils.createAndClickHiddenInput(this.image_url, this.formattedDownloadName);
    },
    showOtherDatas(): void {
      this.card_class = this.card_class.includes("card-up")
        ? "mx-auto my-12 card-style card-down"
        : "mx-auto my-12 card-style card-up";
      this.button_class = this.button_class.includes("rotate-180")
        ? "mr-9 download_button_style rotate-0"
        : "mr-9 download_button_style rotate-180";
      this.text_class = this.text_class.includes("text-up")
        ? "subtitle-style text-subtitle-1 col-style text-down"
        : "subtitle-style text-subtitle-1 col-style text-up";
    },
    formattedDate(date: string | Date): string {
      return Utils.transformDateToYMDHMS(date);
    }
  },
  computed: mapState({
    defineColor(): string {
      const state = store.getters.STATE_BY_ID[store.getters.DEVICE_BY_ID[this.device._id].state];
      return state.color;
    },
    defineBackgroundColor(): CssStyle {
      if (this.last_image && this.device.can_send_image && this.device.state === "Terrain - Posé(e)") {
        const diff = Date.now() - new Date(this.last_image.date).getTime();
        if (this.cameraType === "Lapi" || this.cameraType === "Lapi-observer") {
          if (diff >= 2 * 60 * 60 * 1000 || (this.last_image.nb_jpg === 0 && this.last_image.nb_unknown === 0)) {
            return { backgroundColor: "#FF87A1" };
          } else if (diff >= 60 * 60 * 1000) {
            return { backgroundColor: "#FFEFB2" };
          } else {
            return { backgroundColor: "#CCFFCC" };
          }
        }
        if (this.cameraType === "PyCam3") {
          if (
            diff >= 6 * 60 * 60 * 1000 ||
            !this.last_image.pycam_connexion ||
            Math.abs(this.last_image.pycam_diff_sec) > 10
          ) {
            return { backgroundColor: "#FF87A1" };
          } else if (
            diff >= 3 * 60 * 60 * 1000 ||
            !this.last_image.pycam_record_on ||
            (Math.abs(this.last_image.pycam_diff_sec) > 5 && Math.abs(this.last_image.pycam_diff_sec) < 10)
          ) {
            return { backgroundColor: "#FFEFB2" };
          } else {
            return { backgroundColor: "#CCFFCC" };
          }
        }
      }
      return { backgroundColor: "var(--tertiary-color)" };
    },
    defineBatteryColor(): CssStyle {
      const actual_battery = this.cameraType === "Lapi" ? this.calculate_battery_level : this.pycam_df_p;
      switch (true) {
        case actual_battery >= 30:
          return {
            color: "var(--button-yes-color)"
          };
        case actual_battery >= 15 && actual_battery < 30:
          return {
            color: "var(--alyce-orange)"
          };
        case actual_battery >= 1 && actual_battery < 15:
          return {
            color: "var(--button-no-color)"
          };
        default:
          return {};
      }
    },
    calculate_battery_level(): number {
      const tension_max = 12.6;
      try {
        const tension_number = parseFloat((this.last_image as CameraImage)?.tension.split("V")[0]);
        if (isNaN(tension_number)) return -1;
        if (tension_number <= 9) return 0;
        return Math.round(((tension_number - 9) / (tension_max - 9)) * 100);
      } catch (e) {
        return -1;
      }
    },
    display_last_image(): string {
      return this.last_image
        ? `${process.env.VUE_APP_API}/public/images/${this.last_image.filepath}`
        : this.placeholder_name;
    },
    downloadLink(): string {
      return `${process.env.VUE_APP_API}/public/images/${this.display_last_image}`;
    },
    formattedDownloadName(): string {
      return `${this.device.material_name}_${Utils.transformDateToYMDHMS((this.last_image as CameraImage).date)
        .replaceAll("/", "_")
        .replaceAll(":", "_")
        .replace(" ", "_")}.jpg`;
    },
    camera_image(): number {
      return store.getters.CAMERA_IMAGE_ALL_ID.filter(
        (image_id) => store.getters.CAMERA_IMAGE_BY_ID[image_id].material === this.device._id
      ).length;
    },
    defineCardHeight(): string {
      let height = "390px";
      if (this.last_image) {
        height = this.last_image.icr_mode && this.last_image.icr_mode === "time" ? "643px" : "600px";
      }
      return height;
    },
    cameraType(): string {
      const category = store.getters.DEVICE_BY_ID[this.last_image.material].category;
      return store.getters.CATEGORY_BY_ID[category].name;
    }
  })
});
